/**
 * Simple string interpolation utility to replace placeholders in a string
 * Use when i18next interpolation isn't working correctly
 * 
 * @param {string} template - The string template with placeholders like "{name}"
 * @param {Object} params - An object with keys matching the placeholder names
 * @returns {string} - The interpolated string with placeholders replaced by values
 */
export const interpolate = (template, params) => {
  if (!template) return '';
  if (!params) return template;
  
  return template.replace(/{([^{}]*)}/g, (matched, key) => {
    const value = params[key];
    return typeof value !== 'undefined' ? value : matched;
  });
}; 